import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const LogoutIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 14H2V2H7C7.55 2 8 1.55 8 1C8 0.45 7.55 0 7 0H1C0.45 0 0 0.45 0 1V15C0 15.55 0.45 16 1 16H7C7.55 16 8 15.55 8 15C8 14.45 7.55 14 7 14ZM15.71 7.29L12.71 4.29C12.53 4.11 12.28 4 12 4C11.45 4 11 4.45 11 5C11 5.28 11.11 5.53 11.29 5.71L12.59 7H6C5.45 7 5 7.45 5 8C5 8.55 5.45 9 6 9H12.59L11.3 10.29C11.11 10.47 11 10.72 11 11C11 11.55 11.45 12 12 12C12.28 12 12.53 11.89 12.71 11.71L15.71 8.71C15.89 8.53 16 8.28 16 8C16 7.72 15.89 7.47 15.71 7.29Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default LogoutIcon;
